import { staffActivitySeed } from './activityLogs';

let logs = [...staffActivitySeed].sort(
  (a, b) => new Date(b.at).getTime() - new Date(a.at).getTime(),
);

export function getActivityLogs() {
  return logs;
}

export function findLogsByStaffId(staffId) {
  return logs.filter((l) => l.staffId === staffId);
}

export function addActivityLog(entry) {
  const log = {
    logId: `LOG-${String(logs.length + 1).padStart(3, '0')}`,
    at: new Date().toISOString(),
    ...entry,
  };
  logs = [log, ...logs];
  return log;
}

export function actionTypeLabel(actionType) {
  const map = {
    LOGIN: 'Login',
    CREATE: 'Create',
    UPDATE: 'Update',
    DELETE: 'Delete',
    KYC: 'KYC',
    PASSWORD: 'Password',
    RECOMMEND: 'Recommend',
    DEPLOY: 'Deploy',
    DOCUMENT: 'Documents',
  };
  return map[actionType] || actionType;
}

export function actionBadgeStatus(actionType) {
  if (actionType === 'DELETE') return 'error';
  if (actionType === 'KYC' || actionType === 'DEPLOY') return 'verified';
  if (actionType === 'LOGIN' || actionType === 'PASSWORD') return 'info';
  if (actionType === 'RECOMMEND') return 'pending';
  return 'neutral';
}
